<script>
    import scrollToElement from '../../../util/dom/scroll-to-element';

    export default {
        props: {
            anchor: {
                type: String,
                required: true,
            },
        },
        methods: {
            onClick() {
                setTimeout(() => {
                    scrollToElement(this.anchor);
                }, 400);
            },
        },
        render() {
            return this.$scopedSlots.default({
                onClick: this.onClick,
            });
        },
    };
</script>
